var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "hbp-container hbp-container-above" }, [
    _c("div", { staticClass: "announcement router-view" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "announcement-panel", attrs: { id: "listLabel" } },
        [
          _c("div", { staticClass: "announcement-list" }, [
            _c(
              "div",
              { staticClass: "announcement-list-content" },
              [
                _c(
                  "xui-table",
                  {
                    staticStyle: { width: "100%" },
                    attrs: {
                      data: _vm.latestData,
                      stripe: false,
                      "show-header": false
                    },
                    on: { "row-click": _vm.handleRow }
                  },
                  [
                    _c("xui-table-column", {
                      attrs: { prop: "title", label: "", align: "left" }
                    }),
                    _vm._v(" "),
                    _c("xui-table-column", {
                      attrs: { prop: "stickyOrder", width: "100", label: "" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "span",
                                {
                                  style:
                                    scope.row.stickyOrder == 1
                                      ? "display:block"
                                      : "display:none"
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: require("../../../src/images/ancmt-sticky.png"),
                                      alt: ""
                                    }
                                  })
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("xui-table-column", {
                      staticClass: "is-top",
                      attrs: {
                        prop: "creationDateStr",
                        width: "250",
                        label: ""
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "pager block", attrs: { id: "pageLabel" } },
              [
                _c("xui-pagination", {
                  attrs: {
                    "current-page": _vm.currentPage,
                    "page-size": 10,
                    layout: "total, pager, jumper",
                    total: _vm.total
                  },
                  on: {
                    "current-change": _vm.handleCurrentChange,
                    "update:currentPage": function($event) {
                      _vm.currentPage = $event
                    },
                    "update:current-page": function($event) {
                      _vm.currentPage = $event
                    }
                  }
                })
              ],
              1
            )
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "announcement-breadcrumb" }, [
      _c(
        "div",
        {
          staticClass: "el-breadcrumb",
          attrs: { "aria-label": "Breadcrumb", role: "navigation" }
        },
        [
          _c(
            "span",
            {
              staticClass: "el-breadcrumb__item",
              attrs: { "aria-current": "page" }
            },
            [
              _c(
                "span",
                {
                  staticClass: "el-breadcrumb__inner is-link",
                  attrs: { role: "link" }
                },
                [
                  _c("img", {
                    attrs: { src: require("../../images/ancmt-icon.png") }
                  }),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      "\n                            奖励计划\n                        "
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c("i", {
                staticClass: "el-breadcrumb__separator el-icon-arrow-right"
              })
            ]
          )
        ]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4ddd6ba2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ddd6ba2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/program/Program.vue
// module id = null
// module chunks = 